import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Spinner,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import moment from 'moment-timezone';
import { MDBDataTableV5, MDBIcon } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import classnames from 'classnames';
import { getUser, getUser_v2 } from '../utils/dropdownlist';
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md';
import { FaEdit } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { CSVLink } from 'react-csv';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

const headers = [
  {
    label: 'Order ID',
    key: 'order_id',
  },
  {
    label: 'Order Date',
    key: 'order_date',
  },
  {
    label: 'Service',
    key: 'service_type',
  },
  {
    label: 'Status',
    key: 'order_status',
  },
  {
    label: 'Payment',
    key: 'payment_status',
  },
  {
    label: 'Category',
    key: 'category',
  },
  {
    label: 'Product No.',
    key: 'product_no',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Quantity',
    key: 'qty',
  },
  {
    label: 'Price',
    key: 'price',
  },
  {
    label: 'Schedule Date',
    key: 'schedule_date',
  },
  {
    label: 'Start Time',
    key: 'starttime',
  },
  {
    label: 'End Time',
    key: 'endtime',
  },
  {
    label: 'Customer',
    key: 'customer',
  },
  {
    label: 'Contact',
    key: 'contact',
  },
  {
    label: 'Address',
    key: 'address',
  },
  {
    label: 'Postal Code',
    key: 'postal_code',
  },
  {
    label: 'Order Message',
    key: 'order_msg',
  },
];

const tbcolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Service',
    field: 'service_type',
    sort: 'asc',
  },
  {
    label: 'Status',
    field: 'order_status',
    sort: 'asc',
  },
  {
    label: 'Payment',
    field: 'payment_status',
    sort: 'asc',
  },
  {
    label: 'Category',
    field: 'category',
    sort: 'asc',
  },
  {
    label: 'Product No.',
    field: 'product_no',
    sort: 'asc',
  },

  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  {
    label: 'Quantity',
    field: 'qty',
    sort: 'asc',
  },
  {
    label: 'Price',
    field: 'price',
    sort: 'asc',
  },
  {
    label: 'Schedule Date',
    field: 'schedule_date',
    sort: 'asc',
  },
  // {
  //   label: 'Start Time',
  //   field: 'starttime',
  //   sort: 'asc',
  // },
  // {
  //   label: 'End Time',
  //   field: 'endtime',
  //   sort: 'asc',
  // },
  {
    label: 'Customer',
    field: 'customer',
    sort: 'asc',
  },
  {
    label: 'Contact',
    field: 'contact',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
];

class PackingListOrderDt extends React.Component {
  _isMounted = true;
  PackingListOrder = StorageService.getSession('PackingListOrder');
  access = StorageService.getSession('user_access');
  constructor(props) {
    super(props);
    let storeid =
      this.PackingListOrder && this.PackingListOrder.store_id
        ? this.PackingListOrder.store_id
        : this.props.data.storeList[0].store_id;
    let storeRole = this.access.store.find(x => x.store_id == storeid).role;
    this.state = {
      paymentModal: false,
      redirect: false,
      isLoading: false,
      isManageablePayment:
        storeRole === 'Manager' ||
        storeRole === 'Superuser' ||
        storeRole === 'Admin' ||
        storeRole === 'Supervisor' ||
        storeRole === 'Financial'
          ? true
          : false,
      store_id:
        this.PackingListOrder && this.PackingListOrder.store_id
          ? this.PackingListOrder.store_id
          : this.props.data.storeList[0].store_id,
      storeList: this.props.data.storeList,
      date:
        this.PackingListOrder && this.PackingListOrder.date
          ? this.PackingListOrder.date
          : moment()
              .subtract(1, 'days')
              .tz('Asia/Singapore')
              .format('YYYY-MM-DD'),
      fm_date:
        this.PackingListOrder && this.PackingListOrder.fm_date
          ? this.PackingListOrder.fm_date
          : moment()
              .subtract(1, 'days')
              .tz('Asia/Singapore')
              .format('YYYY-MM-DD'),
      to_date:
        this.PackingListOrder && this.PackingListOrder.to_date
          ? this.PackingListOrder.to_date
          : moment()
              .subtract(1, 'days')
              .tz('Asia/Singapore')
              .format('YYYY-MM-DD'),
      reportList: [],
      paymentList: [],
      payment_amount: '',
      payment_data: '',
      payment_reference: '',
      selectedID: '',
      total_outstanding: '',
    };
  }

  componentDidMount() {
    //if (this.OrderScheduleList) {
    this.getReport();
    this.getPaymentList();
    //}
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
    let data = this.PackingListOrder ? this.PackingListOrder : {};
    data[name] = value;
    StorageService.setSession('PackingListOrder', data);
    this.PackingListOrder = StorageService.getSession('PackingListOrder');
  };

  getPaymentList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3001/v1/payment', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({ paymentList: result.data });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  getReport() {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
    };

    axios
      .post(url + ':3003/v1/order/report/schedule/list/order', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        for (let i of result.data) {
          i.Action = (
            <div className="ps-action-button">
              {i.order_id != 'Total' && (
                <Button
                  className="theme-button theme-button-secondary"
                  onClick={() => this.props.order(i.store_id, i.order_id)}
                >
                  View
                </Button>
              )}
              {/* {i.payment_status === 'Pending Payment' && (
                <Button
                  className="theme-button theme-button-primary-light"
                  onClick={this.paymentModal(i.order_id, i.total_outstanding)}
                >
                  Pay
                </Button>
              )} */}
            </div>
          );
        }

        if (this._isMounted) {
          this.setState({
            reportList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  paymentModal = (order_id = '', total_outstanding = '') => () => {
    if (this.state.isManageablePayment) {
      if (order_id !== '') {
        this.setState({ isLoading: true });
        this.paymentAmount(order_id);
      }
      // return this.setState({
      //   paymentModal: !this.state.paymentModal,
      //   payment_amount: total_outstanding,
      //   selectedID: order_id,
      // });
    }
  };

  offModal = () => () => {
    return this.setState({
      paymentModal: false,
    });
  };

  paymentAmount(order_id) {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: order_id,
      store_id: this.state.store_id,
    };

    axios
      .post(url + ':3003/v1/order/detail', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          paymentModal: !this.state.paymentModal,
          payment_amount: result.data.total_outstanding,
          selectedID: order_id,
          isLoading: false,
        });
      })
      .catch(error => {
        alert(error);
      });
  }

  payment = e => {
    e.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    let payment = this.state.paymentList.find(
      x => x.id == this.state.payment_type,
    );

    let payment_item = {
      payment_id: this.makeid(20),
      payment_type_id: payment.id,
      payment_type: payment.name,
      amount: this.state.payment_amount,
      data: this.state.payment_data,
      reference: this.state.payment_reference,
    };

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: this.state.selectedID,
      store_id: this.state.store_id,
      payment_item: payment_item,
      updated_by: user.email,
    };

    axios
      .post(url + ':3003/v1/order/payment/add', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Reference updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({
          paymentModal: false,
          payment_data: '',
          payment_reference: '',
          payment_amount: '',
        });
        this.getReport();
      })
      .catch(error => {
        alert(error);
      });
  };

  CsvNotFound() {
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    });
  }

  makeid(length) {
    var result = '';
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  render() {
    let data = {
      columns: tbcolumn,
      rows: this.state.reportList,
    };
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Row>
          <Col md={3}>
            <Input
              className="ps-input-small"
              type="select"
              name="store_id"
              value={this.state.store_id}
              onChange={this.changeHandler}
            >
              {this.state.storeList.map(item => {
                return (
                  <option key={item.store_id} value={item.store_id}>
                    {item.name}
                  </option>
                );
              })}
            </Input>
          </Col>
          <Col md={3}>
            <Input
              className="ps-input-small"
              type="date"
              name="fm_date"
              onChange={this.changeHandler}
              value={this.state.fm_date}
            />
          </Col>
          <Col md={1}>
            <p
              style={{
                padding: '0.4rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              To
            </p>
          </Col>
          <Col md={3}>
            <Input
              className="ps-input-small"
              type="date"
              name="to_date"
              onChange={this.changeHandler}
              value={this.state.to_date}
            />
          </Col>
          <Col md={2}>
            <Button className="ps-input-small" onClick={() => this.getReport()}>
              Search
            </Button>
          </Col>
        </Row>

        <Row>
          <Col>
            <CSVLink
              data={this.state.reportList}
              headers={headers}
              filename={
                'PackingList(OrderDate)_' +
                moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') +
                '_' +
                moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') +
                '.csv'
              }
              onClick={() => {
                if (this.state.reportList.length < 1) {
                  this.CsvNotFound();
                  return false;
                }
              }}
            >
              <Button
                type="button"
                className="ps-input-small theme-button-primary"
              >
                Export
              </Button>
            </CSVLink>
          </Col>
        </Row>

        <Row>
          <Col>
            {/* <MDBDataTableV5
              className="ps-order-table th-11"
              data={data}
              displayEntries={false}
              // entriesOptions={[50, 100]}
              entries={100}
              searchTop
              searchBottom={false}
              noRecordsFoundLabel="No data to show"
              fullPagination
              disableRetreatAfterSorting={true}
              responsive={true}
              
            /> */}
            <Table className="ps-table tb-col-13 ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Order ID</Th>
                  <Th>Order Date</Th>
                  <Th>Service</Th>
                  <Th>Status</Th>
                  <Th>Payment</Th>
                  {/* <Th>Category</Th> */}
                  <Th>Product No.</Th>
                  <Th>Name</Th>
                  <Th>Quantity</Th>
                  <Th>Price</Th>
                  <Th>Schedule Date</Th>
                  <Th>Customer</Th>
                  <Th>Contact</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.reportList.length < 1 && (
                  <Tr>
                    <Td colSpan="13">
                      <div className="ps-empty-data">
                        <div className="empty-content">
                          <h4>No data to show</h4>
                        </div>
                      </div>
                    </Td>
                  </Tr>
                )}
                {this.state.reportList.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.order_id}</Td>
                      <Td>{item.order_date}</Td>
                      <Td>{item.service_type}</Td>
                      <Td>{item.order_status}</Td>
                      <Td>{item.payment_status}</Td>
                      {/* <Td>{item.category}</Td> */}
                      <Td>{item.product_no}</Td>
                      <Td>{item.name}</Td>
                      <Td>{item.qty}</Td>
                      <Td>{item.price}</Td>
                      <Td>{item.schedule_date}</Td>
                      <Td>{item.customer}</Td>
                      <Td>{item.contact}</Td>
                      <Td>{item.Action}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
            {/* <Table responsive hover className="ps-table tb-col-4">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Product No.</th>
                  <th>Name</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {this.state.reportList.length < 1 && (
                  <tr>
                    <td colSpan="4">
                      <div className="ps-empty-data">
                        <div className="empty-content">
                          <h4>No data to show</h4>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
                {this.state.reportList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.category}</td>
                      <td>{item.product_no}</td>
                      <td>{item.name}</td>
                      <td>{item.qty}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table> */}
          </Col>
          <Modal
            isOpen={this.state.paymentModal}
            toggle={this.offModal()}
            className={this.props.className}
            centered
            style={{ fontSize: '0.85rem' }}
          >
            <Form onSubmit={this.payment}>
              <ModalHeader toggle={this.offModal()}>Payment</ModalHeader>
              <ModalBody>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Input
                        type="select"
                        name="payment_type"
                        value={this.state.payment_type}
                        onChange={this.changeHandler}
                        required
                      >
                        <option></option>
                        {this.state.paymentList.map(item => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>Amount</Label>
                      <Input
                        type="text"
                        name="payment_amount"
                        value={this.state.payment_amount}
                        onChange={this.changeHandler}
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Remark</Label>
                      <Input
                        type="text"
                        name="payment_data"
                        value={this.state.payment_data}
                        onChange={this.changeHandler}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Reference</Label>
                      <Input
                        type="text"
                        name="payment_reference"
                        value={this.state.payment_reference}
                        onChange={this.changeHandler}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  className="theme-button theme-button-primary"
                  type="submit"
                >
                  Save
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
        </Row>
      </>
    );
  }
}

export default PackingListOrderDt;
